import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const OrderMaterialsTaskAttemptSchema = z.object({
  type: z.literal(TaskType.ORDER_MATERIALS),
  materialsCost: z.number(),
  materialsReceiptFileIds: z.array(z.string()),
  externalId: z.string().optional(),
  vendorId: z.string(),
});

export const OrderMaterialsTaskAttemptDatabaseSchema = z.object({
  type: z.literal(TaskType.ORDER_MATERIALS),
  materialsCost: z.number(),
  materialsReceiptFileIds: z.array(z.string()),
  externalId: z.string().optional(),
  vendorId: z.string().optional(),
});
